module.exports = __webpack_public_path__ + "static/media/2FA.b7103a93.png";